import { IAtualizacao, IFeedback } from "../../Interfaces/Sprint/Sprint";
import Axios from "../Config/API";
import Service from "../Service";

export async function GetBuscarAtualizacaoServices(idUsuario: number) {
    return Service(
        Axios.get<IAtualizacao>(
            `/home/sprint/buscaratualizacoes?idUsuario=${idUsuario}`
        )
    );
}

export async function InserirVisualizacaoSprintServices(feedback: IFeedback) {
    return Service(
        Axios.post(`/home/sprint/inserirvisualizacaosprint`, feedback)
    );
}
